import { z } from 'zod';

/** The list's view, kept in the URL: the page, and whether it shows the deleted surveys. */
export const surveysSearchSchema = z.object({
  deleted: z.boolean().optional().catch(undefined),
  page: z.coerce.number().int().min(1).default(1).catch(1),
});

export type SurveysSearch = z.output<typeof surveysSearchSchema>;

export const SURVEY_TABS = ['summary', 'responses', 'setup'] as const;
export type SurveyTab = (typeof SURVEY_TABS)[number];

/** A survey page's tab and responses page. Without a tab it opens on what it has. */
export const surveySearchSchema = z.object({
  tab: z.enum(SURVEY_TABS).optional().catch(undefined),
  page: z.coerce.number().int().min(1).default(1).catch(1),
});

export type SurveySearch = z.output<typeof surveySearchSchema>;
